/* eslint-disable import/prefer-default-export */
import React from 'react';

import { Modal, Button } from 'antd';

import MultipleCalc from 'components/multipleCalculator';

export const AddLibraryModal = ({ addLibrary, setAddLibrary }) => (
  <Modal
    title="Add new SPD(s) to the User Library"
    visible={addLibrary}
    onCancel={() => setAddLibrary(false)}
    footer={[
      <Button key="close" onClick={() => setAddLibrary(false)}>
        Close
      </Button>,
    ]}
  >
    <MultipleCalc closeAddLibraryModal={setAddLibrary} />
  </Modal>
);
